import { render, staticRenderFns } from "./ServerTable.vue?vue&type=template&id=372bf3d2&scoped=true"
import script from "./ServerTable.vue?vue&type=script&lang=js"
export * from "./ServerTable.vue?vue&type=script&lang=js"
import style0 from "./ServerTable.vue?vue&type=style&index=0&id=372bf3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372bf3d2",
  null
  
)

export default component.exports